export enum ComponentId {
  TYPE = "ownerType",
}
